var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showInactiveBanner,
          expression: "showInactiveBanner",
        },
      ],
      staticClass:
        "top-notification p-1 text-center fixed-top text-white side-right bg-danger",
      attrs: { id: "inactive-client" },
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.$t(
              "inactive-clients.inactiveClientMessage.thisClientIsCurrentlyInactive"
            )
          ) +
          "\n  "
      ),
      _c(
        "a",
        {
          staticClass: "clickable font-weight-bold",
          on: { click: _vm.openModal },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("inactive-clients.inactiveClientMessage.here")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.$t("inactive-clients.inactiveClientMessage.toReactivate")
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }